import React from 'react';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';
import HomeHero from '@component/HomeHero';

const HomeHeroComponent = (props) => {
  const selectOptions = [];
  props?.fields?.children?.map((option, idx) => {
    selectOptions.push({
      label: option.fields.Link.value.text,
      href: option.fields.Link.value.href,
      anchor: option.fields.Link.value.anchor,
      id: idx,
    });
  });

  return (
    <>
      <HomeHero
        welcomeTitle={<Text field={props.fields?.WelcomeText} />}
        selectElementText={props.fields?.SelectElementText?.value}
        imageInfo={
          <Image
            field={props.fields?.HeroImage}
            editable={true}
            imageParams={{ mw: 100, mh: 50 }}
            height={props.fields?.HeroImage?.value?.height}
            width={props.fields?.HeroImage?.value?.width}
            data-sample="other-attributes-pass-through"
            className="home_hero_image"
          />
        }
        options={selectOptions}
        handleChange={(event) => {
          window.open(event?.target?.value, '_self');
        }}
      />
    </>
  );
};
export default HomeHeroComponent;
